import { Fieldset, Legend } from '@paytrace/pt-skel/Component'
import React from 'react'

interface Props {
  children: React.ReactNode;
  title: string;
  className?: string;
}

export default function SectionContainer ({ children, title, className }: Props): React.JSX.Element {
  return (
    <Fieldset className={className}>
        <Legend title={title} />
        {children}
    </Fieldset>
  )
}
